import { fetchAPI } from "@/utils/fetchAPI";

export type FetchUpdateBirth = {
  birth: string;
  username?: string | null;
  email?: string | null;
};

export async function fetchUpdateBirth({ birth, username, email }: FetchUpdateBirth) {
  try {
    const body = {
      birth,
      ...(username !== undefined && { username }),
      ...(email !== undefined && { email }),
    };

    const res = await fetchAPI({
      url: `/account/birthdate`,
      options: {
        method: "PUT",
        body: JSON.stringify(body),
      },
    });
    console.log("=> ~ res:", res);
    return res;
  } catch (error) {
    throw new Error();
  }
}
